import axios from './utils/axios';

const pathPrefix = '/auth/password-reset';

export interface PasswordResetRequest {
  email: string;
}

export interface PasswordResetConfirm {
  token: string;
  new_password: string;
  new_password_confirm: string;
}

export interface PasswordResetUser {
  id?: number;
  email?: string;
}

export interface PasswordResetVerifyResponse {
  valid?: boolean;
  email?: string;
  user?: PasswordResetUser | null;
  message?: string;
}

export interface PasswordResetConfirmResponse {
  message?: string;
  user?: PasswordResetUser | null;
}

export const PasswordResetService = {
  /**
   * Request a password reset email
   */
  requestReset: async (data: PasswordResetRequest) => {
    try {
      const response = await axios.post(`${pathPrefix}/request/`, data);
      return response.data;
    } catch (error) {
      console.error('Password reset request error', error);
      throw error;
    }
  },

  /**
   * Verify the reset token before proceeding to reset form
   */
  verifyToken: async (token: string): Promise<PasswordResetVerifyResponse> => {
    const { data } = await axios.get<PasswordResetVerifyResponse>(
      `${pathPrefix}/verify/${token}/`,
      { suppressErrorToast: true, skipUnauthorizedRedirect: true }
    );
    return data;
  },

  /**
   * Confirm and reset the password
   */
  confirmReset: async (
    data: PasswordResetConfirm
  ): Promise<PasswordResetConfirmResponse> => {
    const { data: response } = await axios.post<PasswordResetConfirmResponse>(
      `${pathPrefix}/confirm/`,
      data,
      { skipUnauthorizedRedirect: true }
    );
    return response;
  },
};
